<div class="relative flex flex-col w-full" style="max-height: 90vh;">
    <div class="flex flex-row justify-between items-center">
        <div class="text-xl font-bold p-4">{{ isEdit ? 'Editar' : 'Nova' }} advertência</div>
        <div class="p-4">
            <button (click)="clear()" mat-icon-button type="button">
                <mat-icon class="text-secondary" [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
            </button>
        </div>
    </div>

    <div class="overflow-auto px-4 py-2">
        <form [formGroup]="form" class="grid grid-cols-1 md:grid-cols-2 gap-3">
            <mat-form-field class="w-full">
                <mat-label>Data</mat-label>
                <input matInput [matDatepicker]="warnPicker" formControlName="warning_date" placeholder="dd/mm/aaaa" />
                <mat-datepicker-toggle matSuffix [for]="warnPicker"></mat-datepicker-toggle>
                <mat-datepicker #warnPicker></mat-datepicker>
                <mat-error>Campo obrigatório</mat-error>
            </mat-form-field>
            <mat-form-field class="w-full">
                <mat-label>Gravidade</mat-label>
                <mat-select formControlName="severity">
                    <mat-option *ngFor="let opt of severityOptions" [value]="opt.value">{{ opt.label }}</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field class="w-full md:col-span-2">
                <mat-label>Motivo</mat-label>
                <input matInput formControlName="reason" />
                <mat-error>Campo obrigatório</mat-error>
            </mat-form-field>
            <mat-form-field class="w-full md:col-span-2">
                <mat-label>Descrição</mat-label>
                <textarea matInput rows="3" formControlName="description"></textarea>
            </mat-form-field>
        </form>

        <div class="mt-4 border-t border-gray-200 dark:border-gray-700 pt-4">
            <h4 class="text-sm font-semibold text-gray-700 dark:text-gray-200 mb-2">Anexo</h4>
            <app-module-attachments
                [module]="'USER_WARNING'"
                [entityId]="entityId"
                [loggedUser]="loggedUser"
                [typeFile]="'Documento'"
                [deferSave]="true"
                [singleFile]="true"
            ></app-module-attachments>
        </div>
    </div>

    <div class="flex justify-end gap-2 px-4 py-4 border-t border-gray-200 dark:border-gray-700">
        <button (click)="clear()" mat-stroked-button type="button" [disabled]="loading">Fechar</button>
        <button (click)="done()" mat-flat-button color="primary" type="button" [disabled]="loading || form.invalid">
            <mat-spinner *ngIf="loading" diameter="18" class="inline-block mr-2"></mat-spinner>
            Salvar
        </button>
    </div>
</div>
